import { module } from 'angular';
import {
  HelpContentsRegistry,
  OverrideRegistry,
} from '@spinnaker/core';

import { ARMORY_SLA_CONFIG_SHIM } from './overrides/shim/shim';
import { SLA_DATASOURCE } from './sla.dataSource'
const applicationAttributesDirective = require('./overrides/config/applicationAttributes.directive.html');
const editApplicationModal = require('./overrides/modal/editApplication.html');
const createApplicationModal = require('./overrides/modal/newapplication.html');

export const SLA_V2_MODULE = 'spinnaker.sla.v2';
module(SLA_V2_MODULE, [
  ARMORY_SLA_CONFIG_SHIM,
  SLA_DATASOURCE
]).run(function (overrideRegistry: OverrideRegistry) {
  'ngInject';
  overrideRegistry.overrideTemplate('editApplicationModal', editApplicationModal);
  overrideRegistry.overrideTemplate('createApplicationModal', createApplicationModal);
  overrideRegistry.overrideTemplate('applicationAttributesDirective', applicationAttributesDirective);
});

HelpContentsRegistry.register('application.slaThresholds.account',
    '(Optional) The name of the account to limit SLA to.  Leave blank to check all load balancers in this application.');
HelpContentsRegistry.register('application.slaThresholds.latency',
    'Maximum average latency (in milliseconds) to limit SLA to.  Defaults to 250ms.');
HelpContentsRegistry.register('application.slaThresholds.appErrors',
    'Maximum number of allowable errors (5xx) from the application.  Defaults to 0.');
HelpContentsRegistry.register('application.slaThresholds.elbErrors',
    'Maximum number of allowable errors (5xx) from the load balancer.  Defaults to 0.');
HelpContentsRegistry.register('application.slaThresholds.healthyHosts',
    'Minimum number of hosts that are healthy, on average.  Defaults to 1.');
HelpContentsRegistry.register('application.slaThresholds.elbList',
    'Comma-separated list of ELB names to apply SLA to.  If left blank, no SLA score will be generated for this application.');

